import React from "react";
import { Col, Row } from "reactstrap";
import { Link } from "react-router-dom";

function CollaborationTabItems(props) {
    return (
        <div className="tab-pane" id="collaboration">
            <Row>
                <Col md="4" className="mt-2">
                    <div className="box-content">
                        <p className="box-head">Hosted Exchange</p>
                        <p className="box-body">
                            Empower your team with a secure and enterprise Hosted Exchange service, purpose-built for
                            your business.
                        </p>
                        <Link className="learn-more" to="/hostedexchange" target="_blank">
                            Learn more <span className="learn-arrow"> </span>
                        </Link>
                    </div>
                </Col>
                <Col md="4" className="mt-2">
                    <div className="box-content">
                        <p className="box-head">Hosted Sharepoint</p>
                        <p className="box-body">
                            Share and collaborate with your team with DETASAD’s SharePoint service, that is purpose
                            built for you.
                        </p>
                        <Link className="learn-more" to="/hostedsharepoint" target="_blank">
                            Learn more <span className="learn-arrow"> </span>
                        </Link>
                    </div>
                </Col>
                <Col md="4" className="mt-2">
                    <div className="box-content">
                        <p className="box-head">Cloud Email Security</p>
                        <p className="box-body">
                            Protect your on-premises or cloud-based email service by our advance email security
                            protection service.
                        </p>
                        <Link className="learn-more" to="/cloudemailsecurity" target="_blank">
                            Learn more <span className="learn-arrow"> </span>
                        </Link>
                    </div>
                </Col>
                <Col md="4" className="mt-2">
                    <div className="box-content">
                        <p className="box-head">Cloud Email Archive</p>
                        <p className="box-body">
                            Get the flexibility and operational efficiency to meet compliance requirements with our
                            Cloud Email Archive service.
                        </p>
                        <Link className="learn-more" to="/cloudemailarchive" target="_blank">
                            Learn more <span className="learn-arrow"> </span>
                        </Link>
                    </div>
                </Col>
                <Col md="4" className="mt-2">
                    <div className="box-content">
                        <p className="box-head">Office 365</p>
                        <p className="box-body">
                            We provide the productivity tools that your team require for collaboration, mobility,
                            reliability and security of your organization with Office365.
                        </p>
                        <Link className="learn-more" to="/office365" target="_blank">
                            Learn more <span className="learn-arrow"> </span>
                        </Link>
                    </div>
                </Col>
            </Row>
        </div>
    );
}

export default CollaborationTabItems;
